import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import BASE_URL from '../config/config';

const Inicio = () => {
  const [soporteDisponible, setSoporteDisponible] = useState(false);
  const [diaSemana, setDiaSemana] = useState(null);
  const [horario, setHorario] = useState(null); // string del backend, ej: "8:00 a.m. - 15:00 p.m. (CET)"

  const token = localStorage.getItem("AuthToken");
  const logged = !!token;
  const navigate = useNavigate();

  const handleCreateTicket = (department) => {
    window.scrollTo(0, 0);
    if (logged) {
      navigate('/nuevo-ticket', { state: { department } });
    } else {
      navigate('/iniciar-sesion');
    }
  };

  // Helpers para parsear "8:00 a.m. - 15:00 p.m. (CET)"
  const toMinutes = (h, m, meridiem) => {
    let hour = parseInt(h, 10);
    const min = parseInt(m, 10);
    const md = (meridiem || '').toLowerCase().replace(/\./g, '');
    if (md === 'pm' && hour !== 12) hour += 12;
    if (md === 'am' && hour === 12) hour = 0;
    return hour * 60 + min;
  };

  const parseHorario = (str) => {
    // captura HH:MM + am/pm opcional, dos veces
    const re = /(\d{1,2}):(\d{2})\s*(a\.?m\.?|p\.?m\.?)?/gi;
    const matches = [...str.matchAll(re)];
    if (matches.length < 2) return null;

    const [ , h1, m1, md1 ] = matches[0];
    const [ , h2, m2, md2 ] = matches[1];
    const start = toMinutes(h1, m1, md1);
    const end = toMinutes(h2, m2, md2);
    return { start, end };
  };

  // Obtener horario desde ajustes
  useEffect(() => {
    const fetchHorario = async () => {
      try {
        const resp = await axios.get(`${BASE_URL}/ajustes/horario`, {
          headers: { Authorization: token }
        });
        // ahora viene como { success, ajuste: { nombre, valor } }
        const valor = resp?.data?.ajuste?.valor;
        if (valor) setHorario(valor);
      } catch (error) {
        // silenciar fallo, puedes poner un fallback si quieres
        setHorario(null);
      }
    };
    fetchHorario();
  }, [token]);

  // Calcular disponibilidad en base al horario (string) para L–V
  useEffect(() => {
    if (!horario) return;

    const ahora = new Date();
    const diaSemanaActual = ahora.getDay(); // 0=Dom, 1=Lun ... 6=Sab
    setDiaSemana(diaSemanaActual);

    // Solo consideramos de lunes a viernes
    if (diaSemanaActual === 0 || diaSemanaActual === 6) {
      setSoporteDisponible(false);
      return;
    }

    const rango = parseHorario(horario);
    if (!rango) {
      setSoporteDisponible(false);
      return;
    }

    const minutosActuales = ahora.getHours() * 60 + ahora.getMinutes();
    setSoporteDisponible(minutosActuales >= rango.start && minutosActuales < rango.end);
  }, [horario]);

  return (
    <main className='inicio'>
      <div className="bg-intro">
        <div className='site-width'>
          <div className='intro'>
            <div className="intro-text">
              <h1>El soporte técnico más cercano <br/>para nuestros clientes</h1>
              <p>Haznos saber tu causa. Crea un ticket y sigue el progreso desde esta misma web.</p>
            </div>
            <div className="intro-info">
              <div className="support-time">
                <img src="/images/servicio-al-cliente.svg" alt="Horario de soporte" />
                <div className="support-text">
                  <p>Soporte Técnico</p>
                <p className='disponible'>Activo</p>
                </div>
              </div>
              <div className="office-time">
                <img src="/images/reloj-azul.svg" alt="Horario de oficina" />
                <div className="office-text">
                  <p>Horario laboral</p>
                  <p>{horario || 'Cargando...'}</p>
                </div>
              </div>
            </div>
          </div>

          {/* departamentos */}
          <div className="departments">
            <div className="department">
              <img src="/images/codigo-cuadrado.svg" alt="Desarrollo" />
              <h2>Dpto. de Desarrollo</h2>
              <p>Si tu cuestión tiene que ver con desarrollo web.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('desarrollo')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
            <div className="department">
              <img src="/images/pincel-de-lapiz.svg" alt="Diseño" />
              <h2>Dpto. de Diseño</h2>
              <p>Si tu cuestión tiene que ver con diseño gráfico.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('diseno')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
            <div className="department">
              <img src="/images/descubrir.svg" alt="marketing" />
              <h2>Dpto. de Marketing</h2>
              <p>Si tu cuestión tiene que ver con marketing digital.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('marketing')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
              
            </div>
            <div className="department">
              <img src="/images/trofeo.svg" alt="redes sociales" />
              <h2>Dpto. de Redes Sociales</h2>
              <p>Si tu cuestión tiene que ver con redes sociales.</p>
              <button
                className='token-ticket'
                onClick={() => handleCreateTicket('redes_sociales')}
              >
                {logged ? 'Crear ticket' : 'Inicia sesión para crear un ticket'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* comunidad */}
      <div className='bg-comunidad'>
        <div className="site-width">
          <div className="comunidad">
            <img src="images/imagen-comunidad.svg" alt="Imagen Comunidad" />
            <div className='texto-comunidad'>
              <h2>Juntos construimos <span>comunidad</span></h2>
              <p>Olvida los correos perdidos en la bandeja de entrada y las conversaciones interminables por correo electrónico.</p>
              <p>En nuestro centro de soporte, trabajamos para hacerte la vida más fácil y te ofrecemos la mejor atención al cliente.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Inicio;
